<template>
  <div class="hamburger-icon" :class="menuState">
    <div class="dash upper"></div>
    <div class="dash middle"></div>
    <div class="dash lower"></div>
  </div>
</template>

<script>
import { gsap } from "gsap";
export default {
  name: "hamburgerIcon",
  data() {
    return {
      tl: null
    };
  },
  props: {
    state: {
      state: Boolean
    }
  },
  mounted() {
    this.initHB();
  },
  methods: {
    initHB() {
      let upper = document.querySelector(".upper");
      let lower = document.querySelector(".lower");
      let middle = document.querySelector(".middle");
      this.tl = gsap.timeline({ paused: true });

      this.tl.to(
        upper,
        {
          duration: 0.25,
          y: 7
        },
        "<"
      );
      this.tl.to(
        lower,
        {
          duration: 0.25,
          y: -7
        },
        "<"
      );

      this.tl.set(
        middle,
        {
          autoAlpha: 0
        },
        ">"
      );
      this.tl.to(
        upper,
        {
          duration: 0.15,
          rotation: 45,
          transformOrigin: "50% 50%"
        },
        "<"
      ),
        this.tl.to(
          lower,
          {
            duration: 0.15,
            rotation: -45,
            transformOrigin: "50% 50%"
          },
          "<"
        );
    }
  },
  computed: {
    menuState() {
      return this.state === true ? "closed" : "opened";
    }
  },

  watch: {
    menuState: {
      handler(nv) {
        if (nv === "opened") {
          this.tl.play();
        } else {
          this.tl.reverse();
        }
      }
    }
  }
};

</script>

<style lang="scss">
.hamburger-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 72px;
}
.dash {
  display: block;
  width: 25px;
  height: 3px;
  background-color: #fff;
  margin: 2px 0;
}
</style>
